// @flow
import React from 'react'
import { Link } from 'react-router-dom'
import config from 'client/config'

const AccessDenied = () => {
  return (
    <div className='login'>
      <span className='login__accent' />
      <div className='login__header'>
        <h3 className='login__title'>Access denied</h3>
        <h4 className='login__subtitle'>You do not have the necessary permissions to access this application. Please contact <a className='login__inline-link' href={`mailto:${config.supportEmail}`}>{config.supportEmail}</a> if you believe this is an error or if you need access to this application</h4>
      </div>
      <Link to='/' className='login__link'>Return to Login Page</Link>
    </div>
  )
}

export default AccessDenied
